/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { SpaceAuthority } from '@/interfaces/character';
import { createModel } from 'ice';

export default createModel({
  state: {
    // type: 'CONSUMER',
    // role: 'ADMIN',
    type: '',
    roleList: [],
    belongSpaceId: '',
    isUpdate: false,
  } as SpaceAuthority,
  reducers: {
    updateCharacterInfo(prevState: SpaceAuthority, payload) {
      return {
        ...prevState,
        ...(payload || {}),
        isUpdate: true,
        // roleList: ['ADMIN', 'AIGC_DESIGNER'],
      };
    },
  },
});
